var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pogressContainer"},[_c('span',{staticClass:"bar",style:('width:' + _vm.progress + '%')},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }